import React from 'react';
import styles from '../styles/statcard.module.css';

const StatCard = ({ title, value, subValue, isLive, children }) => {
    return (
        <div className={`${styles.card} ${isLive ? styles.live : ''}`}>
            <div className={styles.header}>
                <span className={styles.title}>
                    {title}
                    {isLive && <span className={styles.liveIndicator}></span>}
                </span>
            </div>

            <div className={styles.content}>
                <div className={styles.value}>{value}</div>
                {subValue && <div className={styles.subValue}>{subValue}</div>}
            </div>

            {children && (
                <div className={styles.footer}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default StatCard;
